<script setup lang="ts">
    import { InputRow, Combobox } from '@/components/ui/form';
    import { useI18n } from 'vue-i18n';
    import { useEmployeesNotInPayrollData } from '@/composables/useEmployeesNotInPayrollData';
    import { Payroll } from '@/types';

    const props = defineProps<{
        form: any;
        payroll: Payroll;
    }>();

    const { t } = useI18n();

    const { employees, isLoadingEmployees } = useEmployeesNotInPayrollData(props.payroll.id);
</script>

<template>
    <InputRow
        :form="form"
        name="employee_id"
        label="payrolls.add_employee_to_payroll.select_employee"
    >
        <Combobox
            v-model="form.employee_id"
            :options="employees"
            :translate="false"
            :placeholder="t('payrolls.add_employee_to_payroll.select_employee')"
            label-by="full_name"
            value-by="id"
            :loading="isLoadingEmployees"
            :show-remove-button="false"
        />
    </InputRow>
</template>
